/**
 * My Resources Core Atoms - State management for publishable resources
 */

import { atom } from "jotai";
import type { PublishableResource } from "@/isomorphic/schemas/my-resources";

type AsyncStatus = "init" | "loading" | "success" | "error";

// ============================================================================
// PRIVATE STATE ATOMS
// ============================================================================

/**
 * Private atom holding the list of publishable resources
 */
export const _myPublishableResourcesAtom = atom<PublishableResource[]>([]);

/**
 * Status of the fetch operation
 */
export const myPublishableResourcesStatusAtom = atom<AsyncStatus>("init");

/**
 * Error message if fetch failed
 */
export const myPublishableResourcesErrorAtom = atom<string | null>(null);

// ============================================================================
// PUBLIC READ-ONLY ATOMS
// ============================================================================

/**
 * Public read-only atom for publishable resources
 */
export const myPublishableResourcesAtom = atom((get) => get(_myPublishableResourcesAtom));
